import React from 'react';
import Select from 'react-select';
import { IOpcao } from '@/shared/types/selectOption';
import { ReadLotacaoDto } from '@/api.types';
import { UseFormGetValues } from 'react-hook-form';

interface Props {
  getValues: UseFormGetValues<ReadLotacaoDto>;
  colaboradores: IOpcao[];
  defensores: IOpcao[];
  estagiarioid: number;
  estagiarios: IOpcao[];
  estagioid: number;
  estagios: IOpcao[];
  refSelectColaborador: React.Ref<any>;
  refSelectDefensor: React.Ref<any>;
  refSelectEstagiario: React.Ref<any>;
  refSelectEstagio: React.Ref<any>;
  tipoPessoaLotada: number;
  handleSelectChange: (selectedOption: IOpcao | null, options: IOpcao[], field: 'defensor' | 'colaborador' | 'estagiario' | 'estagio') => Promise<void>;
}

export const VinculoPessoaCard: React.FC<Props> = ({
  getValues,
  colaboradores,
  defensores,
  estagiarioid,
  estagiarios,
  estagioid,
  estagios,
  refSelectColaborador,
  refSelectDefensor,
  refSelectEstagiario,
  refSelectEstagio,
  tipoPessoaLotada,
  handleSelectChange,
}) => {

  return (
    <div className="card">
      <div className="card-header text-center">Pessoa</div>
      <div className="card-body">
        <div style={{ display: tipoPessoaLotada === 1 ? 'block' : 'none' }}>
          <label htmlFor="defensor" className="form-label">
            Defensor:
          </label>
          <Select
            id="defensor"
            ref={refSelectDefensor}
            isClearable
            value={defensores.find((a) => a ? a.value === getValues()?.defensor?.id : null)}
            options={defensores}
            placeholder=""
            onChange={(e) => void handleSelectChange(e, defensores, 'defensor')}
          />
        </div>
        <div style={{ display: tipoPessoaLotada === 2 ? 'block' : 'none' }}>
          <label htmlFor="colaborador" className="form-label">
            Colaborador:
          </label>
          <Select
            id="colaborador"
            ref={refSelectColaborador}
            isClearable
            value={colaboradores.find(
              (a) => String(a.value) === String(getValues()?.colaborador?.id),
            )}
            options={colaboradores}
            placeholder=""
            onChange={(e) => {
              void handleSelectChange(e, colaboradores, 'colaborador');
            }}
          />
        </div>
        <div style={{ display: tipoPessoaLotada === 3 ? 'block' : 'none' }}>
          <label htmlFor="estagiario" className="form-label">
            Estagiário:{' '}
          </label>
          <Select
            id="estagiario"
            ref={refSelectEstagiario}
            isClearable
            value={estagiarios.find(
              (a) =>
                a.value === getValues()?.estagio?.estagiario?.id ||
                a.value === estagiarioid,
            )}
            options={estagiarios}
            placeholder=""
            onChange={(e) => {
              void handleSelectChange(e, estagiarios, 'estagiario');
            }}
          />
        </div>
        <div
          className="mt-3"
          style={{ display: tipoPessoaLotada === 3 ? 'block' : 'none' }}
        >
          <label htmlFor="estagio" className="form-label">
            Estágio:{' '}
          </label>
          <Select
            id="estagiovinculo"
            ref={refSelectEstagio}
            isClearable
            defaultValue={
              estagios.find((a) => a.value === getValues()?.estagio?.id) ||
              estagios.find((a) => a.value === estagioid)
            }
            options={estagios}
            placeholder=""
            onChange={(e) => {
              void handleSelectChange(e, estagios, 'estagio');
            }}
          />
        </div>
      </div>
    </div>
  );
};
